var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccessKeyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.5,
    height: 17.961,
    viewBox: "0 0 18.5 17.961",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "key",
    d: "M18.151,2l-1.7,1.7M9.982,10.169a4.675,4.675,0,1,1-6.612,0,4.675,4.675,0,0,1,6.612,0Zm0,0,3.494-3.494m0,0,2.55,2.55L19,6.25,16.451,3.7M13.476,6.675,16.451,3.7",
    transform: "translate(-1.25 -0.939)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessKeyIcon);
export default __webpack_public_path__ + "static/media/access-key-icon.7094d3eed95ecf125437fbf00ab38d78.svg";
export { ForwardRef as ReactComponent };